/** Local midnight 19 June 2026 — sessions logged in before this must sign in again. */
export const AUTH_SESSION_CUTOFF_MS = new Date(2026, 5, 19, 0, 0, 0, 0).getTime();

const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

export function clearStoredAuth() {
    localStorage.removeItem("auth");
    sessionStorage.removeItem("auth");
}

/**
 * @param {object|null|undefined} authObj — parsed auth from local/session storage
 */
export function isStoredAuthSessionValid(authObj) {
    if (!authObj?.token) return false;

    const loginTime = authObj.timestamp;
    if (loginTime == null || typeof loginTime !== "number") {
        return false;
    }

    if (loginTime < AUTH_SESSION_CUTOFF_MS) {
        return false;
    }

    if (Date.now() - loginTime > TWENTY_FOUR_HOURS_MS) {
        return false;
    }

    return true;
}
